import gql from 'graphql-tag';

export const GET_SIGNUP_INFO = gql`
  query GetSignupInfo($userId: String!) {
    getSignupInfo(userId: $userId) {
      userId
      phone
      roleId
      role
      otherRole
      industryId
      industry
      otherIndustry
      companySizeId
      companySize
      regionId
      region
      subRegionId
      subRegion
      from
      fromId
      otherFrom
      hasSkip
      createdAt
    }
  }
`;

export const GET_SIGNUP_INFO_OPTION = gql`
  query GetSignupInfoOption {
    getSignupInfoOption {
        roleOptions {
          roleId
          role
        }
        industryOptions {
          industryId
          industry
        }
        companySizeOptions {
          companySizeId
          companySize
        }
        regionOptions {
          regionId
          region
        }
        subRegionOptions {
          subRegionId
          regionId
          subRegion
        }
        fromOptions {
          fromId
          from
        }
    }
  }
`;
